module.exports = __webpack_public_path__ + "static/media/20210411_075100526_iOS.721b2c63.jpg";